import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'È adatto ai principianti?',
  a: "Sì, partiamo dalle basi fino ai protocolli d'élite."
}, {
  q: 'Ho bisogno di una palestra?',
  a: 'Molti protocolli possono essere iniziati a casa con attrezzatura minima.'
}, {
  q: 'È un pagamento unico?',
  a: 'Sì, nessun abbonamento nascosto.'
}, {
  q: 'Come accedo al materiale?',
  a: 'Riceverai un link di download immediato subito dopo il pagamento.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Domande frequenti" className="bg-transparent" data-id="element-39" data-mp="20315600ybksw">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-40" data-mp="1v5hiqcu3o1pv">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-41" data-mp="op5t505cfs5w">
          ❓ Domande Frequenti
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-42" data-mp="jo9hu1inx3qg">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-43" data-mp="1plibsfdcna87" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-44" data-mp="1pkqmtne9caqw">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-45" data-mp="11v5sy9gkft2u">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-46" data-mp="16q1xua6wiaxd" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-47" data-mp="rzueztczepw5" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-48" data-mp="wxcpvpak7f6s">
                  <div className="overflow-hidden" data-id="element-49" data-mp="mzykckq6cat9">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-50" data-mp="myojxovumqjg">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}